/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_8_DInputs */

const en_mk_tut_gl_8_d = /** @type {(inputs: Mk_Tut_Gl_8_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent work that runs automatically on a schedule you set.`)
};

const id_mk_tut_gl_8_d = /** @type {(inputs: Mk_Tut_Gl_8_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pekerjaan agen yang berjalan otomatis menurut jadwal yang Anda tentukan.`)
};

/**
* | output |
* | --- |
* | "Agent work that runs automatically on a schedule you set." |
*
* @param {Mk_Tut_Gl_8_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_8_d = /** @type {((inputs?: Mk_Tut_Gl_8_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_8_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_8_d(inputs)
	return en_mk_tut_gl_8_d(inputs)
});